import Language from '@arcblock/www/src/components/language';

export default Language;
